import { render, staticRenderFns } from "./NuevaFormaDeTrabajar.vue?vue&type=template&id=503d184e"
import script from "./NuevaFormaDeTrabajar.vue?vue&type=script&lang=js"
export * from "./NuevaFormaDeTrabajar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports